import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styled';

const Burger = ({ open, onChange }) => {
  return (
    <Wrapper open={open} onClick={onChange}>
      <div />
      <div />
      <div />
    </Wrapper>
  );
};

Burger.propTypes = {
  open: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Burger;
